import { render, staticRenderFns } from "./DeliveryPressisionWidget.vue?vue&type=template&id=fc4e9b7a&"
import script from "./DeliveryPressisionWidget.vue?vue&type=script&lang=js&"
export * from "./DeliveryPressisionWidget.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryPressisionWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSelect,QTable,QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSelect,QTable,QTr,QTh,QTd})
